/* eslint-disable react/prop-types */
import React from 'react';
import { Menu as AntdMenu } from 'antd';
import './Menu.less';

const Menu = args => <AntdMenu className="theme-menu" {...args} />;

export default Menu;
